import { resolveComponent as _resolveComponent, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "m-auto px-8 md:px-20" }
const _hoisted_2 = { class: "max-w-screen-2xl m-auto" }
const _hoisted_3 = { class: "py-10 flex justify-between items-center" }
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = { class: "grid grid-cols-[repeat(5,_minmax(0,_1fr))_max-content] gap-4 mb-3" }
const _hoisted_6 = { class: "flex flex-col col-span-2" }
const _hoisted_7 = { class: "flex flex-col" }
const _hoisted_8 = { class: "flex flex-col" }
const _hoisted_9 = { class: "flex flex-col" }
const _hoisted_10 = { class: "flex items-end" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 0,
  class: "text-next-bri col-span-6 text-right"
}
const _hoisted_13 = { class: "flex justify-between" }
const _hoisted_14 = { class: "pt-4" }
const _hoisted_15 = {
  ref: "map",
  style: {"height":"700px"}
}
const _hoisted_16 = { class: "rotate-x-180 overflow-x-scroll" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!
  const _component_NextButton = _resolveComponent("NextButton")!
  const _component_Field = _resolveComponent("Field")!
  const _component_MultiselectOption = _resolveComponent("MultiselectOption")!
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Switcher = _resolveComponent("Switcher")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_TableTooltip = _resolveComponent("TableTooltip")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_NextTable = _resolveComponent("NextTable")!
  const _component_InfiniteLoading = _resolveComponent("InfiniteLoading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
      _createVNode(_component_Loading, { visible: _ctx.loading }, null, 8, ["visible"])
    ])),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Breadcrumbs, { paths: _ctx.getBreadcrumbsPath }, null, 8, ["paths"]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_NextButton, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back())),
              variant: "outline-secondary",
              class: "w-44 text-sm py-2 px-4"
            }, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [
                _createTextVNode(" < Indietro ")
              ])),
              _: 1
            }),
            (_ctx.hasPermission('create fornitori'))
              ? (_openBlock(), _createBlock(_component_NextButton, {
                  key: 0,
                  component: "router-link",
                  to: { name: 'NuovoFornitore' },
                  variant: "primary",
                  class: "w-44 ml-3 text-sm py-2 px-4 m-0 hidden sm:block"
                }, {
                  default: _withCtx(() => _cache[8] || (_cache[8] = [
                    _createTextVNode(" + Aggiungi ")
                  ])),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "flex justify-between items-center" }, [
          _createElementVNode("h3", { class: "text-3xl font-bold" }, "Lista fornitori")
        ], -1)),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_Field, {
              field_name: "Cerca",
              "onUpdate:modelValue": [
                _ctx.lista_fornitori.debounceSearch,
                _cache[1] || (_cache[1] = ($event: any) => ((_ctx.lista_fornitori.search) = $event))
              ],
              modelValue: _ctx.lista_fornitori.search,
              placeholder: "Cerca"
            }, null, 8, ["onUpdate:modelValue", "modelValue"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_Field, {
              field_name: "Settore merceologico",
              placeholder: "Settore merceologico"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_VueMultiselect, {
                  searchable: true,
                  "internal-search": false,
                  multiple: true,
                  trackBy: "id",
                  label: "descrizione",
                  onSearchChange: _ctx.settore_merceologico_autocomplete.search,
                  modelValue: _ctx.settore_merceologico_autocomplete.selection,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.settore_merceologico_autocomplete.selection) = $event)),
                  options: _ctx.settore_merceologico_autocomplete.options,
                  "close-on-select": true,
                  "clear-on-select": true,
                  placeholder: "Settore",
                  deselectLabel: "Deseleziona",
                  selectedLabel: "Selezionato",
                  selectLabel: "Seleziona",
                  class: "next-vue-multiselect"
                }, {
                  tag: _withCtx(({ option, remove }) => [
                    _createVNode(_component_MultiselectOption, {
                      onRemove: ($event: any) => (remove(option))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(option.descrizione), 1)
                      ]),
                      _: 2
                    }, 1032, ["onRemove"])
                  ]),
                  _: 1
                }, 8, ["onSearchChange", "modelValue", "options"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_Field, { field_name: "Qualifica" }, {
              default: _withCtx(() => [
                _createVNode(_component_VueMultiselect, {
                  searchable: true,
                  "internal-search": false,
                  multiple: false,
                  trackBy: "id",
                  label: "text",
                  onSearchChange: _ctx.qualifica_autocomplete.search,
                  modelValue: _ctx.qualifica_autocomplete.selection,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.qualifica_autocomplete.selection) = $event)),
                  options: _ctx.qualifica_autocomplete.options,
                  "close-on-select": true,
                  "clear-on-select": true,
                  placeholder: "Qualifica",
                  deselectLabel: "Deseleziona",
                  selectedLabel: "Selezionato",
                  selectLabel: "Seleziona",
                  class: "next-vue-multiselect-single"
                }, null, 8, ["onSearchChange", "modelValue", "options"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_Field, {
              field_name: "Aziende del gruppo",
              placeholder: "Aziende del gruppo"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_VueMultiselect, {
                  searchable: true,
                  "internal-search": false,
                  multiple: true,
                  trackBy: "id",
                  label: "nome",
                  onSearchChange: _ctx.aziende_gruppo.search,
                  modelValue: _ctx.aziende_gruppo.selection,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.aziende_gruppo.selection) = $event)),
                  options: _ctx.aziende_gruppo.options,
                  "close-on-select": true,
                  "clear-on-select": true,
                  placeholder: "Azienda",
                  deselectLabel: "Deseleziona",
                  selectedLabel: "Selezionato",
                  selectLabel: "Seleziona",
                  class: "next-vue-multiselect"
                }, {
                  tag: _withCtx(({ option, remove }) => [
                    _createVNode(_component_MultiselectOption, {
                      onRemove: ($event: any) => (remove(option))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(option.nome), 1)
                      ]),
                      _: 2
                    }, 1032, ["onRemove"])
                  ]),
                  _: 1
                }, 8, ["onSearchChange", "modelValue", "options"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_NextButton, {
              onClick: _ctx.download,
              disabled: _ctx.loading_download,
              variant: "secondary",
              class: "flex justify-center items-center w-32 px-3 h-[40px]"
            }, {
              default: _withCtx(() => [
                (_ctx.loading_download)
                  ? (_openBlock(), _createBlock(_component_Spinner, {
                      key: 0,
                      class: "w-4 h-4"
                    }))
                  : (_openBlock(), _createElementBlock("span", _hoisted_11, "Download"))
              ]),
              _: 1
            }, 8, ["onClick", "disabled"])
          ]),
          (_ctx.generatingFile)
            ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
                _cache[10] || (_cache[10] = _createTextVNode(" Il file è in generazione, attendi il completamento e scaricalo nella ")),
                _createVNode(_component_RouterLink, {
                  to: { name: 'DownloadCenter' },
                  target: "_blank",
                  class: "underline"
                }, {
                  default: _withCtx(() => _cache[9] || (_cache[9] = [
                    _createTextVNode("sezione download. ")
                  ])),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_Switcher, {
            modelValue: _ctx.tabIndex,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.tabIndex) = $event)),
            options: ['lista', 'Mappa'],
            class: "grow whitespace-nowrap mr-3"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_Paginator, {
            pagination: _ctx.lista_fornitori.paginate
          }, null, 8, ["pagination"])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, null, 512)
        ], 512), [
          [_vShow, _ctx.tabIndex == 1]
        ]),
        _withDirectives(_createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_NextTable, {
              class: "rotate-x-180 w-full border-separate border-spacing-3 py-4 table-fixed",
              cols: _ctx.fornitoriCols,
              "onUpdate:cols": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.fornitoriCols) = $event)),
              rows: _ctx.lista_fornitori.rows,
              onOrderUpdate: _ctx.lista_fornitori.updateCols
            }, _createSlots({ _: 2 }, [
              _renderList(_ctx.lista_fornitori.rows, (c, j) => {
                return {
                  name: `td_${j}_4`,
                  fn: _withCtx(() => [
                    _createVNode(_component_TableTooltip, { inner_class: "relative" }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(c.settori, (option, i) => {
                          return (_openBlock(), _createBlock(_component_MultiselectOption, {
                            key: i,
                            readonly: "true"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(option), 1)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 2
                    }, 1024)
                  ])
                }
              }),
              _renderList(_ctx.lista_fornitori.rows, (c, j) => {
                return {
                  name: `td_${j}_1`,
                  fn: _withCtx(() => [
                    _createTextVNode(_toDisplayString(c.accordo_quadro ? 'Sì' : 'No'), 1)
                  ])
                }
              }),
              _renderList(_ctx.lista_fornitori.rows, (c, j) => {
                return {
                  name: `td_${j}_5`,
                  fn: _withCtx((context) => [
                    _createTextVNode(_toDisplayString(_ctx.QualificheFornitore[c.qualifica].replace('_', ' ')), 1)
                  ])
                }
              }),
              _renderList(_ctx.lista_fornitori.rows, (c, j) => {
                return {
                  name: `td_${j}_6`,
                  fn: _withCtx((context) => [
                    _createVNode(_component_router_link, {
                      to: { name: 'DettaglioFornitore', params: { fid: context.context.row.id } },
                      class: "text-center inset-0 absolute flex items-center justify-center"
                    }, {
                      default: _withCtx(() => _cache[11] || (_cache[11] = [
                        _createElementVNode("i", { class: "icon-chevron_destra" }, null, -1)
                      ])),
                      _: 2
                    }, 1032, ["to"])
                  ])
                }
              })
            ]), 1032, ["cols", "rows", "onOrderUpdate"])
          ]),
          _createVNode(_component_InfiniteLoading, {
            onInfinite: _ctx.lista_fornitori.fetchNextPage,
            identifier: _ctx.lista_fornitori.infiniteIdentifier,
            style: {"min-height":"1px"}
          }, {
            complete: _withCtx(() => _cache[12] || (_cache[12] = [
              _createElementVNode("div", { class: "text-center pb-3" }, "Non ci sono altri fornitori.", -1)
            ])),
            _: 1
          }, 8, ["onInfinite", "identifier"])
        ], 512), [
          [_vShow, _ctx.tabIndex == 0]
        ])
      ])
    ])
  ], 64))
}